/**
 * The Machine type role (design-principles §1) as one class string: mono,
 * uppercase, tracked, muted. For plain-text statuses, stat labels and
 * eyebrows; a chip with a border is a Badge, whose variants carry the
 * same recipe.
 */
export const EYEBROW = 'font-mono text-[11px] uppercase tracking-wider text-muted-foreground'
